export const locale = {
    lang: 'es',
    data: {
      'CONFIGURACION': {
        'CABECERA':{
          'TITULO': 'CONFIGURACIÓN',
          'DESCRIP': ''
        },
        'BOTONES':{
          'BOT1':{
            'TITULO': 'Carga de la lista de colaboradores',
            'BOTON': 'Establecer'
          },
          'BOT2':{
            'TITULO': 'Carga de logotipo de la empresa',
            'BOTON': 'Establecer'
          },
          'BOT3':{
            'TITULO': 'Información sobre requerimientos técnicos',
            'BOTON': 'Ver más...'
          }
        },
        'BD':{
          'TITUHEAD': 'Carga de la base de datos de colaboradores',
          'INFO': 'Cargue la base de datos de colaboradores de su empresa',
          'BOTONES':{
            'DescTemp': 'Descargar plantilla'
          },
          'MENSAJES':{
            'CARGABD': 'Subir base de datos',
            'STATUS': 'ESTADO',
            'CORRECTO': 'La base de datos se cargó correctamente',
            'ERROR': 'Ocurrió un error al cargar la base de datos'
          }
        },
        'LOGO':{
          'TITUHEAD': 'Carga del logotipo de la empresa',
          'INFO': 'Cargue el logotipo de su empresa',
          'MENSAJES':{
            'CARGA': 'Subir logotipo',
            'STATUS': 'ESTADO',
            'CORRECTO': 'El logotipo se cargó correctamente',
            'ERROR': 'Ocurrió un error al cargar el logotipo'
          }
        },
        'REQTEC':{
          'TITUHEAD': 'Información de requerimientos técnicos',
          'INFO': 'Requerimientos de la plataforma para su óptimo funcionamiento',
          'MENSAJES':{
            'CARGA': '',
            'STATUS': 'ESTADO',
            'CORRECTO': 'Se cargó correctamente',
            'ERROR': 'Ocurrió un error al cargar '
          }
        }
      }
    }
};
